import MkuTable from './src/table';

MkuTable.install = function (Vue) {
  Vue.component(MkuTable.name, MkuTable);
};

export default MkuTable;
